import React from "react";
import { connect } from "react-redux";
import ProgressBar from "react-toolbox/lib/progress_bar";
import { Tab, Tabs } from "react-toolbox/lib/tabs";
import { tabChanged } from "manage-modules/redux/manageModulesActions";
import ModuleDetailsTab from "manage-modules/components/card/ModuleDetailsTab";
import ModuleItemsTab from "manage-modules/components/card/ModuleItemsTab";
import ModuleSettingsTab from "manage-modules/components/card/ModuleSettingsTab";
import theme from "manage-modules/components/card/ModuleTabsTheme.css";

const ModuleTabs = ({
  activeTabIndex,
  itemCount,
  itemsLoaded,
  itemsSynced,
  onTabChange,
}) => (
  <Tabs theme={theme} index={activeTabIndex} onChange={onTabChange}>
    <Tab label="Details" icon="info_outline">
      <ModuleDetailsTab />
    </Tab>
    <Tab label="Settings" icon="settings">
      <ModuleSettingsTab />
    </Tab>
    <Tab
      label="Items"
      icon={
        itemsLoaded && itemsSynced ? (
          <span className={theme.countIcon}>{itemCount}</span>
        ) : (
          <ProgressBar theme={theme} type="circular" mode="indeterminate" />
        )
      }
    >
      <ModuleItemsTab />
    </Tab>
  </Tabs>
);

const mapStateToProps = state => {
  const { moduleCard } = state.manageModules;

  return {
    activeTabIndex: moduleCard.activeTabIndex,
    itemCount: moduleCard.items.length,
    itemsLoaded: moduleCard.itemsLoaded,
    itemsSynced: moduleCard.itemsSynced,
  };
};

const mapDispatchToProps = dispatch => ({
  onTabChange: index => {
    dispatch(tabChanged(index));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModuleTabs);
